// extracted by mini-css-extract-plugin
module.exports = {"copy":"FloatingTout-module--copy--2T4eb"};